<template>
  <div class="neon-section">
    <div class="neon-header">
      <h2 class="neon-title">{{ $t('newFeatures.sectionTitle') }}</h2>
      <p class="neon-subtitle">{{ $t('newFeatures.sectionSubtitle') }}</p>
    </div>
    <div class="neon-grid">
      <div class="neon-card" v-for="(item, idx) in features" :key="idx">
        <div class="neon-icon" v-html="item.icon"></div>
        <div class="neon-title2">{{ item.title }}</div>
        <div class="neon-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewFeatures',
  computed: {
    features() {
      const f = this.$t('newFeatures.features', { returnObjects: true });
      return Array.isArray(f) ? f : [];
    }
  }
}
</script>

<style lang="scss" scoped>
.neon-section {
  padding: 64px 0 48px 0;
  background: linear-gradient(120deg, #f8fafc 0%, #e0e7ff 100%);
  text-align: center;
}
.neon-header {
  margin-bottom: 48px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
.neon-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #232946;
  margin-bottom: 0.7rem;
  letter-spacing: 1.5px;
  text-shadow: 0 2px 24px #a5b4fc33;
}
.neon-subtitle {
  font-size: 1.08rem;
  color: #6366f1;
  line-height: 1.7;
  margin-bottom: 0.5rem;
}
.neon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 18px;
  max-width: 1100px;
  margin: 0 auto;
}
.neon-card {
  background: #fff;
  border-radius: 20px;
  border: 2.5px solid transparent;
  box-shadow: 0 0 0 0 #38bdf8, 0 2px 16px 0 #e0e7ef99;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 38px 24px 28px 24px;
  min-height: 220px;
  position: relative;
  cursor: pointer;
  background-clip: padding-box;
  transition: box-shadow 0.3s, border 0.3s, transform 0.3s;
  border-image: linear-gradient(120deg, #38bdf8, #6366f1, #a5b4fc) 1;
  &:hover {
    box-shadow: 0 0 32px 0 #38bdf8cc, 0 8px 32px 0 #6366f1cc;
    border-image: linear-gradient(90deg, #38bdf8, #6366f1, #a5b4fc) 1;
    transform: scale(1.05) rotate(-1deg);
    .neon-title2 {
      color: #6366f1;
      text-shadow: 0 2px 16px #a5b4fc99;
    }
    .neon-icon {
      background: linear-gradient(135deg, #6366f1 0%, #38bdf8 100%);
      filter: drop-shadow(0 0 8px #38bdf8cc);
      ::v-deep svg {
        stroke: #fff;
        filter: drop-shadow(0 0 6px #38bdf8cc);
      }
    }
  }
}
.neon-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: linear-gradient(135deg, #ede9fe 0%, #dbeafe 100%);
  margin-bottom: 18px;
  color: #6366f1;
  text-shadow: 0 0 12px #a5b4fc88;
  transition: color 0.3s, filter 0.3s, background 0.3s;
  ::v-deep svg {
    width: 28px;
    height: 28px;
    stroke: #6366f1;
    transition: stroke 0.3s, filter 0.3s;
  }
}
.neon-title2 {
  font-size: 1.18rem;
  font-weight: 700;
  color: #232946;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 12px #e0e7efcc;
  transition: color 0.3s, text-shadow 0.3s;
}
.neon-desc {
  font-size: 0.98rem;
  color: #6366f1;
  line-height: 1.7;
  text-align: center;
}
@media (max-width: 768px) {
  .neon-section {
    padding: 40px 15px 32px;
  }
  .neon-header {
    margin-bottom: 32px;
    max-width: 100%;
  }
  .neon-grid {
    grid-template-columns: 1fr;
    gap: 18px;
    max-width: 100%;
  }
  .neon-card {
    padding: 22px 10px 16px 10px;
    min-height: 120px;
  }
  .neon-title {
    font-size: 1.1rem;
  }
}
</style>

